var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Type } from "class-transformer";
import { IsArray, IsBoolean, IsDate, IsOptional, IsString } from "class-validator";
export class DocumentDeliveryDto {
}
__decorate([
    IsString()
], DocumentDeliveryDto.prototype, "id", void 0);
__decorate([
    IsString()
], DocumentDeliveryDto.prototype, "patientId", void 0);
__decorate([
    IsString(),
    IsOptional()
], DocumentDeliveryDto.prototype, "initiatingStudyId", void 0);
__decorate([
    IsArray(),
    IsString({ each: true }),
    IsOptional()
], DocumentDeliveryDto.prototype, "additionalStudyIds", void 0);
__decorate([
    IsString()
], DocumentDeliveryDto.prototype, "batchId", void 0);
__decorate([
    IsDate(),
    Type(() => Date)
], DocumentDeliveryDto.prototype, "createdAt", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], DocumentDeliveryDto.prototype, "createdBatch", void 0);
__decorate([
    IsBoolean()
], DocumentDeliveryDto.prototype, "delivered", void 0);
__decorate([
    IsDate(),
    IsOptional(),
    Type(() => Date)
], DocumentDeliveryDto.prototype, "deliveredAt", void 0);
export class CreateDocumentDeliveryInput {
}
__decorate([
    IsString()
], CreateDocumentDeliveryInput.prototype, "batchId", void 0);
__decorate([
    IsString(),
    IsOptional()
], CreateDocumentDeliveryInput.prototype, "initiatingStudyId", void 0);
__decorate([
    IsArray(),
    IsString({ each: true }),
    IsOptional()
], CreateDocumentDeliveryInput.prototype, "additionalStudyIds", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], CreateDocumentDeliveryInput.prototype, "createdBatch", void 0);
